import { useAtomValue } from 'jotai';
import { selectedVerifyRouteAtom } from './constants';
import { useEffect, useState } from 'react';
import { distanceStringMeterToKm, secondsToTimestamp, timeStringtoSecond } from '@/commons/utils';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import styled from 'styled-components';
import * as df from 'date-fns';
import * as XLSX from 'xlsx';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  gap: 1.5rem;
  > div:first-child {
   max-height: 30px;
  //  border: 1px solid blue;
  }
  > div:last-child {
    flex-grow:1;
    height: calc(100% - 30px - 94px - 1.5rem);
    // border: 1px solid red;
  }
  > ul {
    margin:0;
    padding:0;
    max-height: 90px;
    border: 0.8px solid #dddddd;
    > li {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      max-height: 30px;
      text-align: center;
      > span:nth-child(2){
       border-left: 0.8px solid #dddddd;
       border-right: 0.8px solid #dddddd;
      }
    }
    > li:nth-child(2){
     border-top: 0.8px solid #dddddd;
     border-bottom: 0.8px solid #dddddd;
    }
  }
`;

export default function Main() {
  const selectedVerifyRoute = useAtomValue(selectedVerifyRouteAtom);
  const [data, setData] = useState<any>();
  useEffect(() => {
    if (selectedVerifyRoute) {
      setData(refactor(selectedVerifyRoute));
    }
  }, [selectedVerifyRoute]);

  const excelDown = () => {
    const info = [
      [
        'Date',
        data.date,
        'CAR_ID : ' + data.car_id,
        'Version',
        'VRP - ' + data.vehicle?.version?.vrp + ', Model - ' + data.vehicle?.version?.model,
      ],
      [
        '시작종료',
        data.vehicle?.startTime + ' -' + data.vehicle?.endTime,
        '종료지점:' + (data.vehicle?.endType === 1 ? '복귀' : '마지막배송지'),
      ],
    ];
    const infoTable = [
      ['', '시간', '거리'],
      ['TMAP', data?.total.time.tmap, data?.total.distance.tmap],
      ['VRP', data?.total.time.vrp, data?.total.distance.vrp + 'Km'],
    ];
    const header = [
      '순서',
      'ID',
      '배송지',
      '배송지주소',
      '시간차',
      'TMAP',
      'VRP',
      '체류시간',
      '도착예정',
      '배송가능시간',
    ];
    const excelContent = data.destList.map((dItem: any, dIndex: number) => {
      const retVal = [
        dItem.index,
        dItem.id,
        dItem.cName,
        dItem.cAddress,
        dItem.diff,
        dItem.tmap,
        dItem.vrp,
        dItem.dwellTime,
        dItem.arrivalTime,
        dItem.workTime,
      ];
      return retVal;
    });
    const workSheet = XLSX.utils.aoa_to_sheet([...info, ...infoTable, [], header, ...excelContent]);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, data.date);
    XLSX.writeFile(workBook, 'verify_' + data.date + '.xlsx');
  };

  const refactor = (target: any) => {
    if (target) {
      const destList: any[] = [];
      let vrpTotalSeconds = 0;
      let tmapTotalSeconds = 0;
      for (let index = 0; index < target.tmap.points.length; index++) {
        vrpTotalSeconds += timeStringtoSecond(target.vrp.destInfo[index].movingDuration + ':00');
        tmapTotalSeconds += target.tmap.points[index].time;
        const temp = {
          index: index + 1,
          id: target.vrp.destInfo[index].id,
          cName: target.vrp.destInfo[index].name,
          cAddress: target.vrp.destInfo[index].address,
          distance: distanceStringMeterToKm(target.tmap.points[index].distance),
          diff: df.differenceInMinutes(
            df.parse(secondsToTimestamp(target.tmap.points[index].time), 'HH:mm', new Date()),
            df.parse(target.vrp.destInfo[index].movingDuration, 'HH:mm', new Date()),
          ),
          tmap: secondsToTimestamp(target.tmap.points[index].time),
          vrp: target.vrp.destInfo[index].movingDuration + '(' + target.vrp.destInfo[index].waitingDuration + ')',
          arrivalTime: target.vrp.destInfo[index].arrivalTime,
          dwellTime: secondsToTimestamp(target.vrp.destInfo[index].dwellTime.value),
          workTime: JSON.stringify(target.vrp.destInfo[index].workTime),
        };
        destList.push(temp);
      }
      if (target.vehicle?.lastPoint?.time > 0) {
        vrpTotalSeconds += timeStringtoSecond(target.vrp.returnDuration + ':00');
        tmapTotalSeconds += target.vehicle?.lastPoint?.time;
        const temp = {
          id: '복귀',
          cName: '-',
          cAddress: '-',
          distance: secondsToTimestamp(target.vehicle?.lastPoint?.distance),
          tmap: secondsToTimestamp(target.vehicle?.lastPoint?.time),
          vrp: target.vrp.returnDuration,
          arrivalTime: target.vehicle?.endTime,
          diff: df.differenceInMinutes(
            df.parse(secondsToTimestamp(target.vehicle?.lastPoint?.time), 'HH:mm', new Date()),
            df.parse(target.vrp.returnDuration, 'HH:mm', new Date()),
          ),
        };
        destList.push(temp);
      }
      return {
        date: target.deliver_date,
        car_id: target.car_id,
        total: {
          distance: {
            tmap: distanceStringMeterToKm(target.tmap.properties.totalDistance),
            vrp: target.vrp.totalDistance.value,
          },
          time: {
            tmap: secondsToTimestamp(target.tmap.properties.totalTime),
            // tmap: secondsToTimestamp(tmapTotalSeconds) + '/' + secondsToTimestamp(target.tmap.properties.totalTime),
            vrp: secondsToTimestamp(vrpTotalSeconds),
          },
        },
        vehicle: target.vehicle,
        destList,
      };
    }
  };

  return data ? (
    <MainWrap>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>
          Date :{data?.date} / CAR ID : {data?.car_id} / Ver : vrp - {data?.vehicle?.version?.vrp}, model -{' '}
          {data?.vehicle?.version?.model}
          <br />
          시작종료 : {data?.vehicle?.startTime} - {data?.vehicle?.endTime} / 종료지점 :{' '}
          {data?.vehicle?.endType === 1 ? '복귀' : '마지막배송지'}
        </span>
        <span onClick={excelDown}>DOWNLOAD</span>
      </div>
      <ul>
        <li>
          <span>&nbsp;</span>
          <span>시간</span>
          <span>거리</span>
        </li>
        <li>
          <span>TMAP</span>
          <span>{data?.total.time.tmap}</span>
          <span>{data?.total.distance.tmap}</span>
        </li>
        <li>
          <span>VRP</span>
          <span>{data?.total.time.vrp}</span>
          <span>{data?.total.distance.vrp}km</span>
        </li>
      </ul>
      <div>
        <DestList list={data?.destList} />
      </div>
    </MainWrap>
  ) : (
    <></>
  );
}

const DestList = ({ list }: { list: any[] }) => {
  const column: GridColDef[] = [
    { field: 'index', headerName: 'No', width: 20, headerAlign: 'center' },
    { field: 'id', headerName: 'id', width: 100, headerAlign: 'center' },
    { field: 'cName', headerName: '배송지', width: 200, headerAlign: 'center' },
    { field: 'cAddress', headerName: '배송지 주소', flex: 1.2, headerAlign: 'center' },
    { field: 'distance', headerName: '거리', width: 80, headerAlign: 'center', align: 'center' },
    { field: 'diff', headerName: '시간차', width: 80, headerAlign: 'center', align: 'center' },
    { field: 'tmap', headerName: 'TMAP', width: 80, headerAlign: 'center', align: 'center' },
    { field: 'vrp', headerName: 'VRP', width: 110, headerAlign: 'center', align: 'center' },
    { field: 'dwellTime', headerName: '체류시간', width: 80, headerAlign: 'center', align: 'center' },
    { field: 'arrivalTime', headerName: '도착예정', width: 80, headerAlign: 'center', align: 'center' },
    { field: 'workTime', headerName: '배송가능시간', flex: 0.8, headerAlign: 'center', align: 'center' },
  ];
  return <DataGrid disableRowSelectionOnClick columns={column} rows={list && list.length > 0 ? list : []} />;
};
